const t = (t2, e) => t2.length - 1 === e;
export {
  t as isLastValue
};
//# sourceMappingURL=isLastValue.js.map
